const ANALYSIST_TYPES = {
    REPORT_BEGIN: 'REPORT_BEGIN',
    REPORT_SUCCESS: 'REPORT_SUCCESS',
    REPORT_FAILURE: 'REPORT_FAILURE',
  };
  
export default ANALYSIST_TYPES;